import { createModule } from 'saga-slice';
import { crudReducers, noop } from 'saga-slice-helpers';
import { sagaApi } from '#/apis';
import { takeLatest } from 'redux-saga/effects';
import { sagaSuccess, sagaFail } from '+/sagas';


const sagaSlice = createModule({

    name: 'notaries',
    initialState: {
        isFetching: false,
        data: {},
        error: null
    },

    reducers: {
        ...crudReducers({}),
        uploadStamp: noop,
        uploadStampFail: noop,
        uploadStampSuccess: (state, payload) => {

            state.data[payload.id] = payload;
        }
    },

    sagas: A => ({

        [A.create]: {
            *saga ({ payload }) {

                yield sagaApi.post(
                    '/notaries',
                    payload,
                    A.createSuccess,
                    A.createFail
                );
            }
        },
        [A.delete]: {
            *saga ({ payload: id }) {

                yield sagaApi.delete(
                    `/notaries/${id}`,
                    null,
                    A.deleteSuccess,
                    A.deleteFail
                );
            }
        },
        [A.update]: {
            *saga ({ payload }) {
                const { id } = payload;

                yield sagaApi.put(
                    `/notaries/${id}`,
                    payload,
                    A.updateSuccess,
                    A.updateFail
                );
            }
        },
        [A.readOne]: {
            *saga ({ payload: id }) {

                yield sagaApi.get(
                    `/notaries/${id}`,
                    A.readOneSuccess,
                    A.readOneFail
                );
            },
            taker: takeLatest
        },
        [A.readAll]: {
            *saga () {

                yield sagaApi.get(
                    'notaries',
                    A.readAllSuccess,
                    A.readAllFail
                );
            },
            taker: takeLatest
        },
        [A.uploadStamp]: {
            *saga ({ payload }) {

                const { notaryId, file } = payload;
                yield sagaApi.post(`/notaries/${notaryId}/stamp`, file, A.uploadStampSuccess, A.uploadStampFail);
            }
        },


        [A.createSuccess]: sagaSuccess('Notary created', '/notaries'),
        [A.deleteSuccess]: sagaSuccess('Notary deleted'),
        [A.updateSuccess]: sagaSuccess('Notary data updated'),

        [A.createFail]: sagaFail('', '/notaries'),
        [A.deleteFail]: sagaFail(),
        [A.updateFail]: sagaFail()
    })
});

export const { actions } = sagaSlice;
export default sagaSlice;
